import { defineMessages } from "react-intl";
export const messages = defineMessages({
    header: {
        id: "buyout.header",
        defaultMessage: "Buy out leasing contract"
    },
    invalidRegistrationNumber: {
        id: "buyout.invalid-reg-number",
        defaultMessage: "Invalid registration number"
    },
    registrationNumber: {
        id: "buyout.reg-number",
        defaultMessage: "Registration number"
    },
    regNumber_short: {
        id: "buyout.reg-number_short",
        defaultMessage: "RegNo"
    },
    buyoutDate: {
        id: "buyout.date",
        defaultMessage: "Date of buyout"
    },
    invalidMileage: {
        id: "buyout.invalid-mileage",
        defaultMessage: "Mileage needs to be more than 0"
    },
    mileage: {
        id: "buyout.mileage",
        defaultMessage: "Mileage"
    },
    buyoutAmount: {
        id: "buyout.buyout-amount",
        defaultMessage: "Amount"
    },
    kidNumber: {
        id: "buyout.kid-number",
        defaultMessage: "KID"
    },
    accountNumber: {
        id: "buyout.account-number",
        defaultMessage: "Account number"
    },
    calculate: {
        id: "buyout.calculate",
        defaultMessage: "Calculate"
    },
    contractNumber: {
        id: "buyout.contract-number",
        defaultMessage: "Contract number"
    },
    getContract: {
        id: "buyout.get-contract",
        defaultMessage: "Get contract"
    },
    mileageInformationText: {
        id: "buyout.mileage-information-text",
        defaultMessage: "Because of short remaining time on contract you need to supply the current mileage. Kilometers over the allowance will be billed to the customer and subtracted from the buyout price. It is important that this is communicated to the customer."
    },
    buyout: {
        id: "buyout.page.buyout",
        defaultMessage: "Buyout"
    },
    customerName: {
        id: "buyout.page.customerName",
        defaultMessage: "Customer Name"
    },
    startDate: {
        id: "buyout.page.startDate",
        defaultMessage: "Start Date"
    },
    endDate: {
        id: "buyout.page.endDate",
        defaultMessage: "End Date"
    },
    timeLeft: {
        id: "buyout.page.timeLeft",
        defaultMessage: "Time Left"
    },
    status: {
        id: "buyout.page.status",
        defaultMessage: "Status"
    },
    noPermissionView: {
        id: "buyout.api.no-permission",
        defaultMessage: "You do not have permission to view this page."
    },
    loadError: {
        id: "buyout.api.error",
        defaultMessage: "An error occurred while loading data."
    },
    // BuyoutApplications
    applicationNumber: {
        id: "vendor.buyout.agreement-list-appno",
        defaultMessage: "App. number"
    },
    listCustomerName: {
        id: "vendor.buyout.agreement-list-customer-name",
        defaultMessage: "Name"
    },
    makeModel: {
        id: "vendor.buyout.agreement-list-make-model",
        defaultMessage: "Make/model"
    },
    chassiOrRegNumber: {
        id: "vendor.buyout.agreement-list-regno-vin",
        defaultMessage: "Chassi-/reg. number"
    },
    salespersonName: {
        id: "vendor.buyout.agreement-list-salesperson-name",
        defaultMessage: "Salesperson name"
    },
    // BuyoutBreadcrumbs
    dashboard: {
        id: "buyout.breadcrumbs.dashboard",
        defaultMessage: "Dashboard"
    },
    contract: {
        id: "buyout.breadcrumbs.contract",
        defaultMessage: "Avtalenr {number}"
    },
    // BuyoutHeader
    headerTitle: {
        id: "vendor.buyout.header-title",
        description: "Buyout overview title",
        defaultMessage: "Buyout"
    },
    // BuyoutPage
    exportTable: {
        id: "vendor.buyout.export",
        description: "Label for export table button",
        defaultMessage: "Export table"
    },
    emptyStateText: {
        id: "vendor.buyout.empty-state.text",
        description: "Buyout empty-state text",
        defaultMessage: "There are no active agreements available for buyout"
    },
    noPermissionExport: {
        id: "vendor.buyout.export.no-permission",
        defaultMessage: "You do not have permission to export data."
    },
    exportError: {
        id: "vendor.buyout.export.error",
        defaultMessage: "An error occurred while exporting data."
    },
    // BuyoutSearchBar
    appNo: {
        id: "vendor.buyout.search-appno",
        defaultMessage: "Search application number"
    },
    chassis: {
        id: "vendor.buyout.search-chassisno",
        defaultMessage: "Search chassis number"
    },
    reg: {
        id: "vendor.buyout.search-regno",
        defaultMessage: "Search registration number"
    },
    searchCustomerName: {
        id: "vendor.buyout.search-customer-name",
        defaultMessage: "Search customer name"
    },
    Mine: {
        id: "dealer.allapplications.appfilter.mine.label",
        description: "Label for my applications",
        defaultMessage: "My applications"
    },
    All: {
        id: "dealer.allapplications.appfilter.all.label",
        description: "Label for all applications",
        defaultMessage: "All applications"
    },
    // SpecificBuyout/ContractInfoCard
    brandModel: {
        id: "buyout.page.brandModel",
        defaultMessage: "Brand/Model"
    },
    serialReg: {
        id: "buyout.page.serialReg",
        defaultMessage: "Serial/Reg"
    },
    sellerName: {
        id: "buyout.page.sellerName",
        defaultMessage: "Seller Name"
    },
    // SpecificBuyout/DetailsTable
    details: {
        id: "buyout.page.details",
        defaultMessage: "Details"
    },
    originalPrice: {
        id: "buyout.page.details.originalPrice",
        defaultMessage: "Original Price"
    },
    rentAmount: {
        id: "buyout.page.details.rentAmount",
        defaultMessage: "Rent Amount"
    },
    residualValue: {
        id: "buyout.page.details.residualValue",
        defaultMessage: "Financed Residual Value"
    },
    paymentInterval: {
        id: "buyout.page.details.paymentInterval",
        defaultMessage: "Payment Interval"
    },
    duration: {
        id: "buyout.page.details.duration",
        defaultMessage: "Duration"
    },
    monthly: {
        id: "dealer.allapplications.paymentInterval.monthly",
        defaultMessage: "Monthly"
    },
    quarterly: {
        id: "dealer.allapplications.paymentInterval.quarterly",
        defaultMessage: "Quarterly"
    },
    semiannually: {
        id: "dealer.allapplications.paymentInterval.semiannually",
        defaultMessage: "Semi-Annually"
    },
    annually: {
        id: "dealer.allapplications.paymentInterval.annually",
        defaultMessage: "Annually"
    },
    // SpecificBuyout/OfferSection
    offerTitle: {
        id: "buyout.page.offer.title",
        defaultMessage: "Offer"
    },
    offerDownload: {
        id: "buyout.page.offer.download",
        defaultMessage: "Download"
    },
    // SpecificBuyout/PaymentInfoSection
    paymentInfoTitle: {
        id: "buyout.page.paymentInfo.title",
        defaultMessage: "Payment Information"
    },
    paymentInfoAmount: {
        id: "buyout.page.paymentInfo.amount",
        defaultMessage: "Amount"
    },
    // SpecificBuyout/BuyoutSection
    buyoutInfoText: {
        id: "buyout.page.buyout.infoText",
        defaultMessage: "Get a detailed overview of your buyout options."
    },
    buyoutGetPrice: {
        id: "buyout.page.buyout.getPrice",
        defaultMessage: "Get Price"
    },
    buyoutGetNewPrice: {
        id: "buyout.page.buyout.getNewPrice",
        defaultMessage: "Get New Price"
    },
    buyoutContactForBuyout: {
        id: "buyout.page.buyout.contactForBuyout",
        defaultMessage: "Contact Brage Finans for buyout"
    },
    // SpecificBuyout/Overlays/Buyout/BuyoutPriceTable
    vendorPriceTitle: {
        id: "buyout.slidein.forhandlerpris.title",
        defaultMessage: "Vendorprice"
    },
    vendorPriceNew: {
        id: "buyout.slidein.forhandlerpris.new",
        defaultMessage: "With a new agreement to the customer"
    },
    vendorPriceExisting: {
        id: "buyout.slidein.forhandlerpris.existing",
        defaultMessage: "Without a new agreement to the customer"
    },
    lastTerm: {
        id: "buyout.slidein.forhandlerpris.lastTerm",
        defaultMessage: "Last term"
    },
    slideinInfoText: {
        id: "buyout.slidein.infoText",
        defaultMessage: "Pris etter måned tre er kun en indikasjon, ta kontakt dersom du ønsker et reelt tilbud for dette tidspunktet"
    },
    slideinContactLink: {
        id: "buyout.slidein.contactLink",
        defaultMessage: "Contact Brage Finans"
    },
    slideinGenerating: {
        id: "buyout.slidein.generating",
        defaultMessage: "Generating..."
    },
    slideinGenerateOffer: {
        id: "buyout.slidein.generateOffer",
        defaultMessage: "Generate Offer"
    },
    slideinClose: {
        id: "buyout.slidein.close",
        defaultMessage: "Close"
    },
    // SpecificBuyout/Overlays/Email/EmailForm
    slideinEmailAddress: {
        id: "buyout.slidein.email.address",
        defaultMessage: "Email Address"
    },
    slideinEmailInvalid: {
        id: "buyout.slidein.email.invalid",
        defaultMessage: "Please enter a valid email address"
    },
    slideinEmailSend: {
        id: "buyout.slidein.email.send",
        defaultMessage: "Send"
    },
    // SpecificBuyout/Overlays/Email/EmailSentConfirmation
    slideinEmailSent: {
        id: "buyout.slidein.email.sent",
        defaultMessage: "Copy sent to {email}"
    },
    // SpecificBuyout/Overlays/Email/EmailSlidein
    emailSendCopy: {
        id: "buyout.page.offer.sendCopy",
        defaultMessage: "Send copy by email"
    },
    // SpecificBuyout/SpecificBuyoutPage
    contractPageTitle: {
        id: "buyout.page.title",
        defaultMessage: "Contract {number}"
    },
    rowsPerPage: {
        id: "datatable.pagination.labelRowsPerPage",
        defaultMessage: "Rows per page:"
    }
});
//# sourceMappingURL=messages.js.map